/**
 * Detects whether the current browser URL is the IdP authorisation callback.
 *
 * The URL carries either a successful ?code= or an error ?error= query param
 * immediately after the IdP redirects back to the application. Two concerns
 * depend on this check:
 *
 *   1. handleUserLoading must not start a new signinRedirect() here — the only
 *      legitimate action is to complete the code-for-token exchange via
 *      signinRedirectCallback(). Starting a fresh redirect produces a cascade
 *      of rotating ?code= values during login.
 *
 *   2. Any 401 handler that would redirect to /login must be suppressed while
 *      signinRedirectCallback() is mid-flight, because early API calls that
 *      race ahead of the token exchange will legitimately 401.
 *
 * @returns {boolean} True when the page is on the OIDC callback URL.
 */
export const isOnAuthCallbackUrl = (
  pathname = (typeof window !== 'undefined' && window.location.pathname) || '',
  search = (typeof window !== 'undefined' && window.location.search) || '',
) =>
  search.includes('code=') ||
  search.includes('error=') ||
  pathname === '/openid-complete' ||
  pathname.endsWith('/openid-complete') ||
  pathname === '/callback' ||
  pathname.endsWith('/callback')

/**
 * Detects whether the current browser URL is the silent renew iframe path.
 * Matches both flat /silent_renew and tenant-scoped /{tenant}/silent_renew.
 *
 * @param {string} [pathname] - Defaults to window.location.pathname.
 * @returns {boolean}
 */
export const isSilentRenewUrl = (
  pathname = (window.location && window.location.pathname) || '',
) => pathname === '/silent_renew' || pathname.endsWith('/silent_renew')
